'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _index = require('../../../common/boards/index');

var _index2 = _interopRequireDefault(_index);

var _Board = require('./Board');

var _Board2 = _interopRequireDefault(_Board);

var _BoardContainer = require('./BoardContainer');

var _BoardContainer2 = _interopRequireDefault(_BoardContainer);

var _browser = require('../../utils/services/browser');

var _toolbarConstants = require('../../workspace/toolbar/toolbarConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    return (0, _index2.default)({
        containerComponent: _BoardContainer2.default,
        presentationalComponent: _Board2.default,
        tools: [_toolbarConstants.TOOLS.COLOR, _toolbarConstants.TOOLS.ICON],
        tooltip: _browser.isApple ? '⌃⌘B' : 'Ctrl+Alt+B'
    });
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/board/index.js
// module id = 1957
// module chunks = 0